import Vue from "vue";
import App from "./App.vue";
import createRouter from "./router";
import createStore from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/main.scss'//全局CSS
import '@/style/element-variables.scss'

import HeadView from '@/components/headView.vue'
import DialogView from '@/components/dialogView.vue'
import BannerView from '@/components/bannerView.vue'
import FooterView from '@/components/footerView.vue'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.component('HeadView', HeadView)
Vue.component('DialogView', DialogView)
Vue.component('BannerView', BannerView)
Vue.component('FooterView', FooterView)


export default function createApp() {
  const router = createRouter();
  const store = createStore();

  const app = new Vue({
    router,
    store,
    render: (h) => h(App),
  });

  return { app, router, store };
}
